// extracted by mini-css-extract-plugin
module.exports = {"cookieBanner":"AppCookieBanner_cookieBanner__1uf8R","cookieBannerText":"AppCookieBanner_cookieBannerText__GTEFG"};